module.exports = __webpack_public_path__ + "static/media/adobe-xd.f2d9ef0a.svg";